export { default } from "./nodeAttributes";
